// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2018 Ericsson and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

/* message container */
.theia-alert-message-container {
  flex: 1;
  padding: 10px;
}

.theia-alert-message-container i {
  transform: translateY(2px);
  padding-right: 3px;
}

.theia-alert-message-container .theia-message-header,
.theia-alert-message-container .theia-message-content {
  text-overflow: ellipsis;
  overflow: hidden;
}

/* information message */
.theia-info-alert {
  background-color: var(--theia-inputValidation-infoBackground);
  border: var(--theia-border-width) solid
    var(--theia-inputValidation-infoBorder);
  border-radius: 4px;
  color: var(--theia-inputValidation-infoForeground);
  padding: 10px;
}

/* warning message */
.theia-warning-alert {
  background-color: var(--theia-inputValidation-warningBackground);
  border: var(--theia-border-width) solid
    var(--theia-inputValidation-warningBorder);
  border-radius: 4px;
  color: var(--theia-inputValidation-warningForeground);
  padding: 10px;
}

/* error message */
.theia-error-alert {
  background-color: var(--theia-inputValidation-errorBackground);
  border: var(--theia-border-width) solid
    var(--theia-inputValidation-errorBorder);
  border-radius: 4px;
  color: var(--theia-inputValidation-errorForeground);
  padding: 10px;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@theia/core/src/browser/style/alert-messages.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF,sBAAsB;AACtB;EACE,OAAO;EACP,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;EAEE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,6DAA6D;EAC7D;2CACyC;EACzC,kBAAkB;EAClB,kDAAkD;EAClD,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,gEAAgE;EAChE;8CAC4C;EAC5C,kBAAkB;EAClB,qDAAqD;EACrD,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,8DAA8D;EAC9D;4CAC0C;EAC1C,kBAAkB;EAClB,mDAAmD;EACnD,aAAa;AACf","sourcesContent":["/********************************************************************************\n * Copyright (C) 2018 Ericsson and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n/* message container */\n.theia-alert-message-container {\n  flex: 1;\n  padding: 10px;\n}\n\n.theia-alert-message-container i {\n  transform: translateY(2px);\n  padding-right: 3px;\n}\n\n.theia-alert-message-container .theia-message-header,\n.theia-alert-message-container .theia-message-content {\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n/* information message */\n.theia-info-alert {\n  background-color: var(--theia-inputValidation-infoBackground);\n  border: var(--theia-border-width) solid\n    var(--theia-inputValidation-infoBorder);\n  border-radius: 4px;\n  color: var(--theia-inputValidation-infoForeground);\n  padding: 10px;\n}\n\n/* warning message */\n.theia-warning-alert {\n  background-color: var(--theia-inputValidation-warningBackground);\n  border: var(--theia-border-width) solid\n    var(--theia-inputValidation-warningBorder);\n  border-radius: 4px;\n  color: var(--theia-inputValidation-warningForeground);\n  padding: 10px;\n}\n\n/* error message */\n.theia-error-alert {\n  background-color: var(--theia-inputValidation-errorBackground);\n  border: var(--theia-border-width) solid\n    var(--theia-inputValidation-errorBorder);\n  border-radius: 4px;\n  color: var(--theia-inputValidation-errorForeground);\n  padding: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
